import { useState, useEffect } from "react";
import TutorialModal from "./TutorialModal";

export default function ImmersiveTutorial({ open, onClose, onComplete, steps, GameInterface }) {
  const [currentStep, setCurrentStep] = useState(0);
  const step = steps[currentStep];
  const isLast = currentStep === steps.length - 1;

  useEffect(() => { if (!open) setCurrentStep(0); }, [open]);

  if (!open) return null;

  const handleNext = () => { isLast ? onComplete() : setCurrentStep(s => s + 1); };
  const handlePrev = () => { setCurrentStep(s => Math.max(0, s - 1)); };

  return (
    <div style={{ position:"fixed", inset:0, zIndex:100 }}>
      <GameInterface spotlightZone={step.spotlightZone} highlightTab={step.highlightTab} />
      {step.spotlightZone && (
        <div style={{ position:"fixed", inset:0, zIndex:101, background:"rgba(0,0,0,.68)", pointerEvents:"none" }}/>
      )}
      <TutorialModal
        step={step}
        currentStep={currentStep}
        totalSteps={steps.length}
        onPrev={handlePrev}
        onNext={handleNext}
        onClose={onClose}
        isLast={isLast}
      />
    </div>
  );
}